export default __webpack_public_path__ + "static/gallery-img8-811de5a81c8345b74fb5c769b24240e9.jpg";